// extracted by mini-css-extract-plugin
export default {"options":"styles_options__Gv-L3","hide":"styles_hide__ZWCgd","reverse":"styles_reverse__3mLRO"};